import "./city.eab2e3fd.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $7WQrb = parcelRequire("7WQrb");

var $4OBpG = parcelRequire("4OBpG");

var $27Ysw = parcelRequire("27Ysw");

var $800sp = parcelRequire("800sp");
parcelRequire("hGXTG");
parcelRequire("9mFH0");
parcelRequire("d4bXs");

var $juzok = parcelRequire("juzok");
class $492726d5e82fb811$export$26ce8ff19ea0d516 {
    constructor(config){
        this.client = (0, $juzok.createDirectus)(config.apiUrl).with((0, $juzok.rest)());
    }
    async getHome() {
        // Use the same language detection logic as LanguageSelector
        const languageCode = this.getValidLanguageCode();
        console.log("Fetching home data with language code:", languageCode);
        this.langFilter = {
            translations: {
                _filter: {
                    languages_code: {
                        _eq: languageCode
                    }
                }
            }
        };
        try {
            console.log("Making API request to fetch home data...");
            const response = await this.client.request((0, $juzok.readSingleton)("home", {
                fields: [
                    "translations.*"
                ],
                deep: {
                    ...this.langFilter
                }
            }));
            console.log("Raw API response:", response);
            if (!response || !response.translations || !Array.isArray(response.translations) || response.translations.length === 0) {
                console.warn("No translations found for language:", languageCode, "Trying fallback...");
                // Try without language filter as fallback
                const fallbackResponse = await this.client.request((0, $juzok.readSingleton)("home", {
                    fields: [
                        "translations.*"
                    ]
                }));
                console.log("Fallback API response:", fallbackResponse);
                if (!fallbackResponse || !fallbackResponse.translations || !Array.isArray(fallbackResponse.translations) || fallbackResponse.translations.length === 0) throw new Error("No home translations found even without language filter");
                // Use the first available translation
                const translatedResult = fallbackResponse.translations[0];
                console.log("Using fallback translation:", translatedResult);
                return this.buildHomeModel(translatedResult);
            }
            const translatedResult = response.translations[0];
            console.log("Using filtered translation:", translatedResult);
            return this.buildHomeModel(translatedResult);
        } catch (error) {
            console.error("Error fetching home data:", error);
            throw error;
        }
    }
    getValidLanguageCode() {
        // Return selectedLanguage if in storage
        const storedLanguage = sessionStorage.getItem('selectedLanguage');
        if (storedLanguage && (storedLanguage === 'de' || storedLanguage === 'fr')) return storedLanguage;
        // Get browser language, if its de or fr use that, else default to de
        const browserLanguage = navigator.language.slice(0, 2);
        const selectedLanguage = browserLanguage === 'de' || browserLanguage === 'fr' ? browserLanguage : 'de';
        // Store the determined language so it's consistent across services
        sessionStorage.setItem('selectedLanguage', selectedLanguage);
        return selectedLanguage;
    }
    buildHomeModel(translatedResult) {
        if (!translatedResult) throw new Error("No translated result provided");
        const home = {
            titel: translatedResult.titel || "",
            subtitle1: translatedResult.subtitle1 || "",
            subtitle2: translatedResult.subtitle2 || "",
            description: translatedResult.description || "",
            contentbox: translatedResult.contentbox?.map((content)=>({
                    title: content.title || "",
                    description: content.description || "",
                    width: Number(content.width) || 1
                })) || []
        };
        console.log("Built home model:", home);
        return home;
    }
}



var $lmk8H = parcelRequire("lmk8H");

var $7zLhD = parcelRequire("7zLhD");
class $b4e14b6b8da86996$export$b94310965bed44e6 extends (0, $27Ysw.DefaultComponent) {
    static get componentStyles() {
        return (0, $800sp.css)`
      .grid-container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: var(--gutter-m);
      }
      .full-width {
        grid-column: span 2;
      }

      .half-width {
        grid-column: span 1;
      }
      @media screen and (max-width: 480px) {
        .half-width {
          grid-column: span 2;
        }
      }
      .max-content {
        max-width: 800px;
        width: 100%;
      }
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        // Add the event listener when the component is connected to the DOM
        window.addEventListener('refetch-data', this.handleRefetchWidget);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up the event listener when the component is removed
        window.removeEventListener('refetch-data', this.handleRefetchWidget);
    }
    afterComponentInitialized() {
        (0, $7zLhD.initializeSentry)(this.config);
        this.fetchHome();
    }
    async fetchHome() {
        try {
            // Ensure config is properly loaded
            if (!this.config || !this.config.apiUrl) {
                console.warn("Config not ready, retrying...");
                await this.configService.fetchConfig();
                this.config = this.configService.getConfig();
            }
            if (!this.config.apiUrl) throw new Error("API URL not available in config");
            console.log("Fetching home data with API URL:", this.config.apiUrl);
            this.homeService = new (0, $492726d5e82fb811$export$26ce8ff19ea0d516)(this.config);
            this.home = await this.homeService.getHome();
            this.retryCount = 0; // Reset retry count on success
            this.requestUpdate();
        } catch (error) {
            console.error(`Failed to fetch home data (attempt ${this.retryCount + 1}):`, error);
            if (this.retryCount < this.maxRetries) {
                this.retryCount++;
                const delay = this.retryCount * 2000; // Exponential backoff: 2s, 4s, 6s
                console.log(`Retrying in ${delay}ms...`);
                setTimeout(()=>{
                    this.fetchHome();
                }, delay);
            } else console.error("Max retries reached. Giving up on fetching home data.");
        }
    }
    /**
   * Injects CSS into the page to style the dynamically loaded iframe.
   * This is called after the script has successfully loaded.
   */ applyStylesToPetitionWidget() {
        // This style tag will be appended to the widget's container div.
        const style = document.createElement('style');
        style.textContent = `
      .petition-widget iframe {
        width: 100%;
        border: none;
        min-height: 600px; /* Adjust as needed */
      }
    `;
        const petitionWidgetDiv = document.querySelector('.petition-widget');
        if (petitionWidgetDiv) // Append styles directly to the container to ensure they apply
        // to the iframe created by the script.
        petitionWidgetDiv.appendChild(style);
    }
    /**
   * Loads the third-party petition form script into a container outside the component.
   * It cleans up any existing widget before loading the new one.
   */ async loadPetitionForm() {
        // Wait for the component's update cycle to complete before manipulating the DOM.
        // @ts-ignore: updateComplete is available on LitElement
        await this.updateComplete;
        // Find the container div in the global document, not the shadowRoot.
        const petitionWidgetDiv = document.querySelector(".petition-widget");
        if (!petitionWidgetDiv) {
            console.error(".petition-widget div not found in document. Cannot load form.");
            return;
        }
        // Clear any old content (script, iframe, style tags, etc.) to ensure a clean reload.
        petitionWidgetDiv.innerHTML = '';
        // Create and append the new script
        const script = document.createElement("script");
        script.id = "controlsfhift-embed-sign-form-script";
        script.src = "https://act.campax.org/assets/embed_sign_form.js";
        script.async = true;
        // Set the petition URL based on the selected language
        const languageCode = sessionStorage.getItem("selectedLanguage") || navigator.language;
        if (languageCode === "fr") script.setAttribute("data-petition-url", "https://act.campax.org/petitions/convention-des-droits-de-l-enfant-de-l-onu/embed?source=partner-homepage&bucket=partner-org");
        else script.setAttribute("data-petition-url", "https://act.campax.org/petitions/uno-kinderrechtskonvention/embed?source=partner-homepage&bucket=partner-org");
        // When the script loads, apply the necessary styles.
        script.onload = ()=>{
            this.applyStylesToPetitionWidget();
        };
        script.onerror = ()=>console.error("Failed to load the petition form script.");
        petitionWidgetDiv.appendChild(script);
    }
    firstUpdated() {
        this.loadPetitionForm();
    }
    render() {
        return (0, $800sp.html)`
      <bnn-banner
        .title="${this.home?.titel}"
        .subtitle1="${this.home?.subtitle1}"
        .subtitle2="${this.home?.subtitle2}"
        .isHome="${true}"
      ></bnn-banner>
      <bnn-content-container>
        <div class="grid-container">
          ${this.home?.contentbox?.map((content)=>{
            return (0, $800sp.html)`<div
              class="${(0, $lmk8H.classMap)({
                "content-box": true,
                "full-width": content.width === 1,
                "half-width": content.width === 0.5
            })}"
            >
              <h2>${content.title}</h2>
              <p .innerHTML="${content.description}"></p>
            </div>`;
        })}
        </div>
      </bnn-content-container>
    `;
    }
    constructor(...args){
        super(...args), /**
   * Handles the global data refetch event.
   */ this.handleRefetchWidget = ()=>{
            console.log("Refetching home content and petition widget...");
            this.fetchHome();
            this.loadPetitionForm();
        }, this.retryCount = 0, this.maxRetries = 3;
    }
}
(0, $7WQrb.__decorate)([
    (0, $4OBpG.state)()
], $b4e14b6b8da86996$export$b94310965bed44e6.prototype, "home", void 0);
$b4e14b6b8da86996$export$b94310965bed44e6 = (0, $7WQrb.__decorate)([
    (0, $4OBpG.customElement)("bnn-home")
], $b4e14b6b8da86996$export$b94310965bed44e6);


//# sourceMappingURL=app.28caf2db.js.map
